import { Skeleton, Stack } from '@mui/material'
import { storeElement } from 'GlobalStores/StoreElement'
import { observer } from 'mobx-react-lite'

const GenealogyCardSkeleton = observer(({ rowCount = 5 }) => {
    const isMobile = storeElement.IsMobile()

    return (
        <Stack
            display="flex"
            flexDirection={isMobile ? 'row-reverse' : 'row'}
            sx={{ width: isMobile ? 'max-content' : '100%' }}>
            {/* Left Column - Names */}
            <Stack sx={{ minWidth: '400px', flex: 1 }}>
                {/* Search Bar Skeleton */}
                <Stack sx={{ borderBottom: '1px solid #D1D9E2', height: '50px', justifyContent: 'center', padding: '0 16px' }}>
                    <Skeleton variant="rounded" height={32} animation="wave" />
                </Stack>
                {/* Date Skeleton */}
                <Stack sx={{ borderBottom: '1px solid #D1D9E2', height: '50px', justifyContent: 'center', padding: '15px 12px' }}>
                    <Skeleton variant="text" width="60%" height={24} sx={{ margin: '0 auto' }} animation="wave" />
                </Stack>
                {/* Name Items Skeleton */}
                {[...Array(rowCount)].map((_, index) => (
                    <Stack
                        key={index}
                        sx={{
                            backgroundColor: index % 2 === 0 ? '#F5F5F5' : '#FFFFFF',
                            minHeight: '55px',
                            height: '63px',
                            borderBottom: '1px solid #D1D9E2',
                            padding: '10px 24px',
                            justifyContent: 'center'
                        }}>
                        <Stack direction="row" alignItems="center" gap="12px">
                            {index !== 0 && <Skeleton variant="circular" width={16} height={16} animation="wave" />}
                            <Stack sx={{ flex: 1 }}>
                                <Skeleton variant="text" width={index === 0 ? '40%' : '60%'} height={22} animation="wave" />
                                <Stack direction="row" gap="8px">
                                    <Skeleton variant="text" width={80} height={16} animation="wave" />
                                    <Skeleton variant="text" width={60} height={16} animation="wave" />
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>
                ))}
            </Stack>

            {/* Right Column - Data */}
            <Stack sx={{ flex: 1 }}>
                {/* Period Selector Skeleton */}
                <Stack
                    sx={{
                        padding: '15px 12px',
                        borderBottom: '1px solid #D1D9E2',
                        height: '50px',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderLeft: '1px solid #D1D9E2',
                        borderRight: isMobile ? '1px solid #D1D9E2' : '0px',
                        backgroundColor: '#F5F5F5',
                        flexDirection: 'row'
                    }}>
                    <Skeleton variant="circular" width={20} height={20} animation="wave" />
                    <Skeleton variant="text" width={100} height={24} animation="wave" />
                    <Skeleton variant="circular" width={20} height={20} animation="wave" />
                </Stack>

                {/* Column Headers and Data Skeleton */}
                <Stack flexDirection="row" sx={{ width: '100%' }}>
                    {['CPV', 'AL', 'PV', 'TV', 'OV'].map((title, colIndex) => (
                        <Stack key={title} sx={{ flex: 1 }}>
                            {/* Header */}
                            <Stack
                                sx={{
                                    padding: '15px 12px',
                                    borderBottom: '1px solid #D1D9E2',
                                    height: '50px',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    minWidth: '50px',
                                    ...(colIndex === 0 && {
                                        borderLeft: '1px solid #D1D9E2',
                                        borderRight: '1px solid #D1D9E2'
                                    }),
                                    ...(colIndex === 4 && {
                                        borderRight: isMobile ? '1px solid #D1D9E2' : '0px'
                                    })
                                }}>
                                <Skeleton variant="text" width={30} height={20} animation="wave" />
                            </Stack>
                            {/* Data Rows */}
                            {[...Array(rowCount)].map((_, rowIndex) => (
                                <Stack
                                    key={rowIndex}
                                    sx={{
                                        padding: '15px 12px',
                                        borderBottom: '1px solid #D1D9E2',
                                        minHeight: '63px',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        minWidth: '50px',
                                        ...(colIndex === 0 && {
                                            borderLeft: '1px solid #D1D9E2',
                                            borderRight: '1px solid #D1D9E2'
                                        }),
                                        ...(colIndex === 4 && {
                                            borderRight: isMobile ? '1px solid #D1D9E2' : '0px'
                                        })
                                    }}>
                                    <Skeleton variant="text" width={40} height={20} animation="wave" />
                                </Stack>
                            ))}
                        </Stack>
                    ))}
                </Stack>
            </Stack>
        </Stack>
    )
})

export default GenealogyCardSkeleton
